module.exports = __webpack_public_path__ + "static/tusas-7-a2b5a8a8d057f22ccc9d119e3ca2f1d0.png";